module.exports = __webpack_public_path__ + "static/media/MEDIAW.3c0293fb.svg";